import {useState} from "react";

function NavBar() {
  const [nav, setNav] = useState<string>("/admin");

  return { nav, setNav};
}

export default NavBar;